/**
 * Peer Benchmarking Page
 * 
 * Wraps the Peer Benchmarking module for use as a route page.
 */

import React from 'react';
import PeerBenchmarking from '../modules/peer-benchmarking';

export default function PeerBenchmarkingPage() {
  return <PeerBenchmarking />;
}
